import { CustomElement } from '@aurelia/runtime-html';
export const name = "mt-button";
export const template = "<a\n  class=\"ob-button ob-button--normal ${disabled ? 'ob-disabled !cursor-not-allowed' : ''} justify-center items-center\"\n  click.trigger=\"!disabled && onclick && onclick()\">\n  <span>${label}</span>\n  <au-slot></au-slot>\n  <div if.bind=\"loading\" class=\"spinner-border spinner-border-sm\" role=\"status\"></div>\n</a>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
